
import React from 'react';
import { useSelector } from 'react-redux';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import Text from '../../common/client/components/Text';

import { getIsknDateTitle } from '../../reducers/iskn';

import MapDialog from '../map/MapDialog';
import ParHistoryDialog from '../common/iskn/ParHistoryDialog';
import OverviewTitle from '../projectOverviewPage/OverviewTitle';
import IsknParInfo from '../common/iskn/IsknParInfo';
import IsknParList from '../common/iskn/IsknParList';
import IfComp from '../common/IfComp';

const classNames = mergeStyleSets({
    AnalyzeDefunctParResult: {
        border: '1px solid #dddddd',
        padding: 16,
    },
    AnalyzeIsknResult: {
    },
    AnalyzeParWithPrevious: {
        paddingBottom: 8,
        borderBottom: '1px solid #dddddd',
        marginBottom: 8
    },
    par: {
    },
    parTitle: {
        paddingTop: 8,
        paddingBottom: 8,
        marginBottom: 8,
        backgroundColor: '#dddddd'
    },
    parNew: {
        width: 500
    },
    parOld: {
        width: 800
    },
    scroll: {
        overflowY: 'auto',
        height: 1 // hack for scroll
    }
});


const AnalyzeParWithPrevious = ({parIdNew, parIdOld, parInfoNew, parInfoOld}) => {

    const dataNew = {
        par: parInfoNew.par.filter(item => item.par_id === parIdNew),
        opsub: parInfoNew.opsub,
        tel: parInfoNew.tel,
        vla: parInfoNew.vla
    };

    const dataOld = {
        par: parInfoOld.par.filter(item => parIdOld.indexOf(item.par_id) !== -1),
        opsub: parInfoOld.opsub,
        tel: parInfoOld.tel,
        vla: parInfoOld.vla
    }

    const handleShowHistory = async (parItem) => {
        const dialog = ParHistoryDialog();
        await dialog.open(parItem.par_id);
    }

    const handleShowInMap = async (parItem) => {
        const dialog = MapDialog();
        await dialog.open(parItem);
    }

    const tools = [{
        title: 'Historie',
        handler: handleShowHistory
    }, {
        title: 'Do mapy',
        handler: handleShowInMap
    }]

    return (
        <Stack horizontal className={classNames.AnalyzeParWithPrevious}>
            <Stack.Item className={classNames.parOld}>
                <IsknParList
                    compact={false}
                    isknDate="actual"
                    data={dataOld}
                    tools={tools}
                />
            </Stack.Item>
            <Stack.Item className={classNames.parNew}>
                <IsknParInfo
                    data={dataNew}
                    showTelLink={false}
                    tools={tools}
                />
            </Stack.Item>
        </Stack>
    );
}

const AnalyzeParWithPreviousList = ({isknDateResult}) => {
    let arr = [];
    for (let parIdNew  in isknDateResult.parInfo.parData) {
        let parIdOld = isknDateResult.parInfo.parData[parIdNew];
        let flag = true;
        if (parIdOld.length === 1) {
            if (parIdNew === parIdOld[0]) {
                flag = false;
            }
        }
        if (flag) {
            arr.push([parIdNew, parIdOld]);
        }
    }
    return (
        <Stack verticalFill>
            <Stack.Item>
                <Stack horizontal className={classNames.parTitle}>
                    <Stack.Item className={classNames.parOld}>
                        <Text>Původní parcely</Text>
                    </Stack.Item>
                    <Stack.Item className={classNames.parNew}>
                        <Text>Aktuální parcela</Text>
                    </Stack.Item>
                </Stack>
            </Stack.Item>
            <Stack.Item grow className={classNames.scroll}>
                {arr.slice(0, 10).map((item, index) => {
                    return (
                        <AnalyzeParWithPrevious
                            key={index}
                            parIdNew={item[0]}
                            parIdOld={item[1]}
                            parInfoNew={isknDateResult.parInfo.parInfoNew}
                            parInfoOld={isknDateResult.parInfo.parInfoOld}
                        />
                    );
                })}
            </Stack.Item>
        </Stack>
    );
}

const AnalyzeIsknResult = ({isknDateResult}) => {

    const isknDateTitle = useSelector(state => getIsknDateTitle(state.iskn, isknDateResult.isknDate));

    return (
        <Stack verticalFill className={classNames.AnalyzeIsknResult}>
            <Stack.Item>
                <Text>Seznam zaniklých parcel v datové sadě: </Text>
                <Text bold >{isknDateTitle}</Text>
            </Stack.Item>
            <Stack.Item grow className={classNames.par}>
                <AnalyzeParWithPreviousList
                    isknDateResult={isknDateResult}
                />
            </Stack.Item>
        </Stack>
    );
}

const AnalyzeIsknResults = ({isknDateResults}) => {

    const item = isknDateResults[0];

    return (
        <AnalyzeIsknResult
            key={item.isknDate}
            isknDateResult={item}
        />
    );
}

const AnalyzeDefunctParResult = ({
    data,
    isLoaded
}) => {

    return (
        <Stack verticalFill className={classNames.AnalyzeDefunctParResult}>
            <OverviewTitle title="ANALÝZA ZANIKLÝCH PARCEL" />
            <IfComp cond={!isLoaded}>
                <Text>Načítám data...</Text>
            </IfComp>
            <IfComp cond={isLoaded && data}>
                <AnalyzeIsknResults
                    isknDateResults={data?.isknDate || []}
                />
            </IfComp>
        </Stack>
    );
}

export default AnalyzeDefunctParResult;
